module.exports = __webpack_public_path__ + "img/female_income.b8e4db36.png";